<template>
  <div class="rest-footer">
    <div class="w">
      <!-- <a class="float-icon back-wrap Pos-f" @click="goTop">
        <i class="el-icon-arrow-up"></i>
      </a>-->
      <div>
        <div class="clearfix rest-f-top">
          <el-col class="rest-f-top-item" :span="6">
            <img src="../assets/images/footer-icon1-aia.png" align="center" />
            <span>品类齐全</span>
          </el-col>
          <el-col class="rest-f-top-item" :span="6">
            <img src="../assets/images/footer-icon3-aia.png" align="center" />
            <span>正品采购</span>
          </el-col>
          <el-col class="rest-f-top-item" :span="6">
            <img src="../assets/images/footer-icon5-aia.png" align="center" />
            <span>售后无忧</span>
          </el-col>
          <el-col class="rest-f-top-item" :span="6">
            <img src="../assets/images/footer-icon6-aia.png" align="center" />
            <span>准时到达</span>
          </el-col>
        </div>
        <div class="clearfix rest-f-middle w">
          <div class="clearfix left-content Fl-l">
            <dl>
              <dt>了解上班族</dt>
              <dd>
                <div @click="goToDetail({ title: '关于我们' })">
                  <a class="content"> <span class="dot">·</span>关于我们 </a>
                </div>
              </dd>
              <dd>
                <div @click="goToDetail({ title: '联系我们' })">
                  <!--  -->
                  <a class="content"> <span class="dot">·</span>联系我们 </a>
                </div>
              </dd>
              <dd>
                <div @click="goToDetail({ title: '企业文化' })">
                  <!-- -->
                  <a class="content"> <span class="dot">·</span>企业文化 </a>
                </div>
              </dd>
            </dl>

            <dl>
              <dt>购物指南</dt>
              <dd>
                <div @click="goToDetail({ title: '购买流程' })">
                  <a class="content"> <span class="dot">·</span>购买流程 </a>
                </div>
              </dd>
              <dd>
                <div @click="goToDetail({ title: '支付方式' })">
                  <a class="content"> <span class="dot">·</span>支付方式 </a>
                </div>
              </dd>
              <dd>
                <div @click="goToDetail({ title: '票券兑换' })">
                  <a class="content"> <span class="dot">·</span>票券兑换 </a>
                </div>
              </dd>
            </dl>

            <dl>
              <dt>配送说明</dt>
              <dd>
                <div @click="goToDetail({ title: '配送服务' })">
                  <!-- -->
                  <a class="content"> <span class="dot">·</span>配送服务 </a>
                </div>
              </dd>
              <dd>
                <div @click="goToDetail({ title: '配送查询' })">
                  <!--  -->
                  <a class="content"> <span class="dot">·</span>配送查询 </a>
                </div>
              </dd>
            </dl>
            <dl>
              <dt>售后规则</dt>
              <dd>
                <div @click="goToDetail({ title: '服务总则' })">
                  <a class="content"> <span class="dot">·</span>服务总则 </a>
                </div>
              </dd>
              <dd>
                <div @click="goToDetail({ title: '取消订单' })">
                  <a class="content"> <span class="dot">·</span>取消订单 </a>
                </div>
              </dd>
              <dd>
                <div @click="goToDetail({ title: '退款明细' })">
                  <a class="content"> <span class="dot">·</span>退款明细 </a>
                </div>
              </dd>
              <dd>
                <div @click="goToDetail({ title: '售后保障' })">
                  <a class="content"> <span class="dot">·</span>售后保障 </a>
                </div>
              </dd>
            </dl>
          </div>
          <div class="right-content">
            <div class="right-content-chat">
              <img
                src="../assets/images/code.png"
                class="picture"
                style="height:117px;width:117px;"
              />
              <p>扫码关注了解更多</p>
            </div>
            <div class="right-content-logo">
              <img
                src="../assets/images/sbz_logo_botton.png"
                class="picture"
                style="width:197px;height:50px;"
              />
              <p class="tel">400-088-8635</p>
              <p class="time">周一至周日 08:30-18:00</p>
              <!-- <p class="time">客服邮箱 {{serviceInfo.email}}</p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rest-f-tail">
      <div class="footer">
        <div class="rest-f-legal-link">
          <a @click="$router.replace({ path: '/' })">首页</a>
          <a @click="goToDetail({ title: '关于我们' })">关于我们</a>
          <a @click="goToDetail({ title: '联系我们' })">联系我们</a>
          <a @click="goToDetail({ title: '' }, 'business')">企业申请</a>
          <a @click="goToDetail({ title: '' }, 'agreement')">用户协议</a>
          <!-- <a :to="{}">诚聘英才</a> -->
          <span>客服电话:400-088-8635</span>
        </div>
        <div class="rest-f-legal-ba">
          <a href="http://www.beian.miit.gov.cn/" target="_blank"
            >备案/许可证号：沪ICP备17048375号-1</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serviceInfo: ""
    };
  },
  methods: {
    goTop() {
      window.scrollBy(0, -1000);
      var scrolldelay = setTimeout(this.goTop(), 1000);
      var sTop = document.documentElement.scrollTop + document.body.scrollTop;
      if (sTop == 0) clearTimeout(scrolldelay);
    },
    goToDetail(query, name = "introduce") {
      let routeUrl = this.$router.resolve({
        path: "/" + name,
        query: query
      });
      window.open(routeUrl.href, "_blank");
    }
  }
};
</script>

<style lang="less" scoped>
.rest-footer {
  height: 350px;
  color: #fff;
  background-image: url("../assets/images/bottom_bg.jpeg");
  padding-top: 30px;
  margin-top: 40px;
  .rest-f-top {
    .rest-f-top-item:last-child {
      text-align: right;
    }
    .rest-f-top-item:first-child {
      text-align: left;
    }
    .rest-f-top-item {
      text-align: center;
      span {
        font-size: 20px;
        font-weight: 500;
        margin-left: 10px;
      }
      img {
        width: 66px;
        height: 66px;
      }
    }
  }
  .rest-f-middle {
    border-top: 1px solid #caced1;
    margin-top: 30px;
    dl {
      float: left;
      height: 120px;
      width: 160px;
      a {
        color: #ededed;
      }
      a:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .coverage {
      padding-top: 20px;
    }
    .left-content {
      width: 60%;
    }
    .right-content {
      width: 40%;
      display: flex;
      div {
        flex: 1;
        margin-top: 20px;
      }
      .right-content-logo {
        text-align: center;
      }
      .tel {
        font-size: 33px;
        font-weight: 400;
        font-style: italic;
        color: rgba(253, 254, 255, 1);
        padding: 0;
        margin: 17px 0;
      }
    }
  }
  .rest-f-tail {
    padding: 10px;
    background-color: #fff;
    text-align: center;
    a,
    span {
      color: #494949;
      min-width: 100px;
      border-right: 1px solid #ddd;
      line-height: 26px;
      cursor: pointer;
    }
    .rest-f-legal-link {
      span:last-child {
        border: none;
      }
    }
    a:last-child {
      border: none;
    }
    a:hover {
      color: #55c3fd;
    }
  }
}
.float-icon {
  right: 40px;
  bottom: 80px;
  z-index: 1000;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 20%;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 20px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/bottom-content.vue